import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"

export interface AddShaderSockets extends MaterialNodeSockets {
    inputs: {
        shader: "closure" // found in inputs: closure; found in settings: -; inferred from data: -
        shader_001: "closure" // found in inputs: closure; found in settings: -; inferred from data: -
    }
    settings: {}
    outputs: {
        shader: "closure"
    }
}

export const addShaderDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeAddShader,
    },
    nodeClass: "AddShader",
    validation: {
        returns: z.strictObject({
            shader: materialClosureOutput,
        }),
        parameters: z.strictObject({
            inputs: z.strictObject({
                shader: optionalMaterialInput,
                shader_001: optionalMaterialInput,
            }),
            settings: z.strictObject({}),
            ui: materialUiSchema,
        }),
    },
    ui: {
        label: "Add Shader",
        color: "#2d8a5d",
        items: [
            {name: "shader", label: "Shader", valueType: "closure", output: true},
            {name: "shader", label: "Shader", valueType: "closure", input: true, setting: false},
            {name: "shader_001", label: "Shader", valueType: "closure", input: true, setting: false},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
} satisfies MaterialNodeDefinition<AddShaderSockets>
